import React from 'react';
import BackButton from './BackButton';

function SavedSearchesPage({ setPage, savedSearches, handleSearch, deleteSavedSearch }) {
  
  const runSearch = (query) => {
    setPage('search');
    if (handleSearch) {
      handleSearch(null, query);
    }
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this saved search?')) {
      deleteSavedSearch(id);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      <header style={{ padding: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <BackButton onClick={() => setPage('search')} />
          <img
            src="/logo.svg"
            alt="PatTrak Logo"
            style={{
              height: '32px',
              cursor: 'pointer'
            }}
            onClick={() => setPage('search')}
          />
        </div>
      </header>

      <main style={{ maxWidth: '800px', margin: '80px auto', padding: '0 16px' }}>
        <h1 style={{ fontSize: '36px', fontWeight: 'bold', color: '#1d2934', marginBottom: '16px' }}>
          Saved Searches
        </h1>
        
        {(!savedSearches || savedSearches.length === 0) ? (
          <p style={{ fontSize: '16px', color: '#5e778a' }}>You haven't saved any searches yet.</p>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {savedSearches.map((search) => (
              <div key={search.id} style={{ border: '1px solid #5e778a', padding: '16px', borderRadius: '8px' }}>
                <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '8px', color: '#1d2934' }}>
                  {search.query}
                </h3>
                <div style={{ fontSize: '14px', color: '#5e778a', marginBottom: '12px' }}>
                  Saved: {search.created_at}
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    onClick={() => runSearch(search.query)}
                    style={{
                      background: '#53dafc',
                      color: '#1d2934',
                      border: 'none',
                      padding: '8px 16px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    Run Search Again
                  </button>
                  <button
                    onClick={() => handleDelete(search.id)}
                    style={{
                      background: '#ff4444',
                      color: 'white',
                      border: 'none',
                      padding: '8px 16px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontSize: '14px',
                      fontWeight: '600'
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>

      <footer style={{
        padding: '32px 16px',
        textAlign: 'center',
        borderTop: '1px solid #e0e0e0',
        marginTop: '80px',
        color: '#5e778a',
        fontSize: '14px'
      }}>
        By using PatTrak, you agree to our Terms and have read our Privacy Policy.
      </footer>
    </div>
  );
}

export default SavedSearchesPage;
